import React, { useRef } from 'react';
import { useContext } from 'react';
import { SchedulerContext } from '../../SchedulerContext';
import { Appointments } from '@devexpress/dx-react-scheduler-material-ui';
import { makeStyles } from 'tss-react/mui';
import {
  useIsExtraSmallScreen,
  useIsSmallScreen,
} from '../../../../../../../../Hooks/useFullscreenView';

export interface IBookingType {
  /** The start date. */
  startDate: string;
  /** The end date. */
  endDate: string;
  /** The title. */
  title?: string;
  /** The all day flag. */
  allDay?: boolean;
  /** Specifies the appointment recurrence rule. */
  rRule?: string | undefined;
  /** Specifies dates excluded from recurrence. */
  exDate?: string | undefined;
  /** Any other properties. */
  bookingId: string;
  bookingNumber: string;
  aktStartDate?: string;
  aktEndDate?: string;
  location?: IResource;
  resourceName: string | null | undefined;
  aktivityType: string | undefined;
  activityId: string;
  activity?: unknown;
  prelBokad?: boolean | null | undefined;
  resourceNameList: (string | null)[];
  mooreBookings?: boolean;
  bokningsbar: boolean;
  dayName?: boolean;
  redDay?: boolean;
  groupOffset?: number;
  groupWidth?: number;
  bokningssignatur?: string;
  isPerson?: boolean;
}

export interface IResource {
  resName: string;
  resId?: string;
}

// TODO jss-to-tss-react codemod: Unable to handle style definition reliably. ArrowFunctionExpression in CSS prop.
// TODO jss-to-tss-react codemod: Unable to handle style definition reliably. ArrowFunctionExpression in CSS prop.
const useStyles = makeStyles<{ type: any; bokningsbar: any }>()(
  (theme, props) => ({
    threeDotAppointment: {
      '& > :first-of-type': {
        border: 'none',
        backgroundColor: 'white !important',
        width: 'fit-content',
        '& > :first-of-type': {
          backgroundColor: 'none',
          background: 'none',
          color: theme.palette.common.black,
          '& > :first-of-type': {
            fontWeight: '900',
            color: theme.palette.primary.main,
          },
          '& > :nth-of-type(2)': {
            display: 'none',
          },
          '& > :nth-of-type(3)': {
            display: 'none',
          },
        },
      },
    },
    /** Used to be able to override appointment default styling */
    appointmentOverride: {},
    appointment: {
      '&.Appointment-clickableAppointment': {
        backgroundColor: props.bokningsbar
          ? props.type
            ? (theme.customProperties.AktivitetColors.stalltid.bokningsbar as unknown as Record<string, string>)[
                props.type
              ]
            : (theme.customProperties.AktivitetColors.stalltid as unknown as string)
          : props.type
          ? (theme.customProperties.AktivitetColors.stalltid as unknown as Record<string, string>)[props.type]
          : (theme.customProperties.AktivitetColors.stalltid as unknown as string),
        '&:hover': {
          backgroundColor: props.bokningsbar
            ? props.type
              ? (theme.customProperties.AktivitetColors.stalltid.bokningsbar as unknown as Record<string, string>)[
                  props.type
                ]
              : (theme.customProperties.AktivitetColors.stalltid as unknown as string)
            : props.type
            ? (theme.customProperties.AktivitetColors.stalltid as unknown as Record<string, string>)[props.type]
            : (theme.customProperties.AktivitetColors.stalltid as unknown as string),
        },
      },
    },
    fullWidth: {
      '&.Appointment-clickableAppointment': {
        width: 'calc(100% + 10px)',
      },
    },
  })
);

export const AppointmentComponent = (props: Appointments.AppointmentProps) => {
  const data = props.data as IBookingType;
  const color = data?.aktivityType?.toLowerCase();
  const bokningsbar = data.bokningsbar;
  const isXbridgeBooking = data.aktivityType === 'O';
  const schedulerContext = useContext(SchedulerContext);
  const isSmallScreen = useIsSmallScreen();
  const isExtraSmallScreen = useIsExtraSmallScreen();
  let t = useRef<string | number | NodeJS.Timeout | undefined>(undefined);
  let hoverTime = 500;

  const { classes, cx } = useStyles({
    type: color,
    bokningsbar: bokningsbar,
  });

  let isStalltid: boolean = false;
  if (
    props.data.aktStartDate !== props.data.startDate ||
    props.data.aktEndDate !== props.data.endDate
  ) {
    isStalltid = true;
  }

  const showTooltip = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    props.onClick?.({ data: props.data, target: e.target });
  };

  const mouseEnter = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    if (!props.data.mooreBookings) {
      if (!isSmallScreen || !isExtraSmallScreen) {
        t.current = setTimeout(() => {
          showTooltip(e);
        }, hoverTime);
      }
    }
  };

  const mouseLeave = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    if (!props.data.mooreBookings) {
      if (!isSmallScreen || !isExtraSmallScreen) {
        clearTimeout(t.current);
      }
    }
  };

  return (
    <span
      style={{ backgroundColor: 'white' }}
      className={cx({
        [classes.threeDotAppointment]:
          props.data.mooreBookings &&
          schedulerContext.currentViewName === 'Month',
      })}
    >
      <Appointments.Appointment
        className={cx(classes.appointmentOverride, {
          [classes.appointment]: isStalltid,
          [classes.fullWidth]:
            schedulerContext.currentViewName !== 'Month' && !props.data.allDay,
        })}
        {...props}
        onClick={
          isXbridgeBooking || data.dayName
            ? undefined
            : props.data.mooreBookings
            ? () => {
                schedulerContext.changeMooreDayView(props.data);
              }
            : props.onClick
        }
        onMouseEnter={mouseEnter}
        onMouseLeave={mouseLeave}
      />
    </span>
  );
};
